/*
• If only one lot is returned, no rows are shown

• Minimum lots to show one row on desktop is 3

• Minimum lots to show one row on tablet/mobile is 2

• Minimum lots to show two rows on desktop is 5

• Minimum lots to show two rows on tablet/mobile is 3

• Lot P1 should be the only lot that is repeated on desktop and tablet/mobile to fill in the last spot

• Minimum to show subsequent rows (3, 4, 5) etc should two one lot than the lots needed for the total. So row three which we would need 9 lots (three for row 1, three for row 2, and three for row 3) would need a minimum of 8 lots to show. P1 would fill in the P9 spot.

•• For row 4 which we would need 12 lots for (three for 1, three for row 2, three for row 3, and four row 4) would need 11 lots. P1 would fill in the P9 spot.
*/

import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';

export const blender = (itemIds: any, promotedItemIds: any, columns: number) => {
    if (promotedItemIds.length < columns) {
        return itemIds;
    }

    if (columns === 3) {
        if (promotedItemIds.length % 3 === 1) {
            promotedItemIds.pop(promotedItemIds.length - 1);
        }
        if (promotedItemIds.length % 3 === 2) {
            promotedItemIds.push(promotedItemIds[0]);
        }
    } else {
        // columns = 2
        if (promotedItemIds.length % 2 !== 0) {
            promotedItemIds.push(promotedItemIds[0]);
        }
    }

    const filteredItemIds = chunk(
        itemIds.filter((item) => !promotedItemIds.includes(item)),
        columns * 2
    );

    promotedItemIds = chunk(promotedItemIds, columns);
    const mixedArray = [promotedItemIds.shift()];
    while (filteredItemIds.length) {
        mixedArray.push(filteredItemIds.shift());
        if (promotedItemIds.length) {
            mixedArray.push(promotedItemIds.shift());
        }
    }

    return flatten(mixedArray);
};
